/** Signed shortest arc from `before` to `after` on a 180 degree axis circle. */
export function axisDelta(before, after) {
    const wrapped = (((after - before) % 180) + 180) % 180;
    return wrapped > 90 ? wrapped - 180 : wrapped;
}
function change(eye, field, before, after, delta, bases = [undefined, undefined]) {
    const [beforeBase, afterBase] = bases;
    const carried = {
        ...(beforeBase === undefined ? {} : { beforeBase }),
        ...(afterBase === undefined ? {} : { afterBase }),
    };
    if (before === undefined) {
        if (after === undefined)
            return { eye, field, kind: 'unchanged' };
        return { eye, field, kind: 'added', after, ...carried };
    }
    if (after === undefined)
        return { eye, field, kind: 'removed', before, ...carried };
    if (before === after && beforeBase === afterBase) {
        return { eye, field, kind: 'unchanged', before, after, ...carried };
    }
    return { eye, field, kind: 'changed', before, after, ...delta(before, after), ...carried };
}
const quarterDelta = (before, after) => ({ deltaQuarters: after - before });
const degreeDelta = (before, after) => ({ deltaDegrees: axisDelta(before, after) });
const millimetreDelta = (before, after) => ({ deltaMillimetres: after - before });
const noDelta = () => ({});
const asQuarters = (d) => d;
function prismChange(eye, field, previous, current) {
    const baseOf = (p) => p === undefined ? undefined : 'base' in p ? p.base : p.baseDegrees;
    return change(eye, field, asQuarters(previous?.magnitude), asQuarters(current?.magnitude), quarterDelta, [baseOf(previous), baseOf(current)]);
}
function eyeChanges(eye, previous, current) {
    return [
        change(eye, 'sphere', asQuarters(previous.sphere), asQuarters(current.sphere), quarterDelta),
        change(eye, 'cylinder', asQuarters(previous.cylinder), asQuarters(current.cylinder), quarterDelta),
        change(eye, 'axis', previous.axis, current.axis, degreeDelta),
        change(eye, 'add', asQuarters(previous.add), asQuarters(current.add), quarterDelta),
        change(eye, 'intermediateAdd', asQuarters(previous.intermediateAdd), asQuarters(current.intermediateAdd), quarterDelta),
        prismChange(eye, 'prismHorizontal', previous.prismHorizontal, current.prismHorizontal),
        prismChange(eye, 'prismVertical', previous.prismVertical, current.prismVertical),
        prismChange(eye, 'prismOblique', previous.prismOblique, current.prismOblique),
        change(eye, 'backVertexDistance', previous.backVertexDistance, current.backVertexDistance, millimetreDelta),
        change(eye, 'balanceLens', previous.isBalanceLens === true ? 1 : 0, current.isBalanceLens === true ? 1 : 0, noDelta),
    ];
}
/** Every compared field of both eyes, right eye first, in the order of `CompareField`. */
export function comparePrescriptions(previous, current) {
    return [
        ...eyeChanges('od', previous.od, current.od),
        ...eyeChanges('os', previous.os, current.os),
    ];
}
//# sourceMappingURL=compare.js.map